/* ============================================================
   MARVIQ — assets/product.js
   Variant selection is driven by real Shopify product/variant JSON
   (embedded server-side) — no fake client-side variants.
   ============================================================ */
(function () {
  "use strict";

  var jsonScript = document.querySelector('script[type="application/json"][id^="ProductJson-"]');
  if (!jsonScript) return;

  var product;
  try { product = JSON.parse(jsonScript.textContent); } catch (e) { return; }

  var sectionKey = jsonScript.id.replace("ProductJson-", "");
  var extra = (window.MARVIQ && window.MARVIQ.product && window.MARVIQ.product[sectionKey]) || {};
  var moneyFormat = extra.moneyFormat || "₹{{amount}}";

  var selectedOptions = (product.selected_or_first_available_variant || product.variants[0]).options.slice();

  var section = document.getElementById("ProductSection");
  if (!section) return;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var noDecimals = amount.split(".")[0];
    if (moneyFormat.indexOf(".00") === -1) amount = Number(amount).toLocaleString("en-IN");
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals);
  }

  function findVariant(options) {
    return product.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === options[i]; });
    });
  }

  function isCombinationAvailable(optionIndex, value) {
    var testOptions = selectedOptions.slice();
    testOptions[optionIndex] = value;
    // Only require the tested option to match; other positions are open (any).
    return product.variants.some(function (v) {
      return v.options[optionIndex] === value && v.available;
    });
  }

  function render(variant) {
    if (!variant) return;

    var priceEl = document.getElementById("pdPrice");
    if (priceEl) {
      var html = "<b>" + formatMoney(variant.price) + "</b>";
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var savePct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        html += ' <span class="old">' + formatMoney(variant.compare_at_price) + "</span>";
        html += ' <span class="save">Save ' + savePct + "%</span>";
      }
      priceEl.innerHTML = html;
    }

    var stockEl = document.getElementById("pdStock");
    if (stockEl) {
      stockEl.classList.remove("low", "out");
      if (!variant.available) {
        stockEl.textContent = "Sold Out";
        stockEl.classList.add("out");
      } else if (variant.inventory_management && variant.inventory_quantity <= 10) {
        stockEl.textContent = "Only " + Math.max(variant.inventory_quantity, 0) + " left";
        if (variant.inventory_quantity <= 5) stockEl.classList.add("low");
      } else {
        stockEl.textContent = "In Stock";
      }
    }

    var skuEl = document.getElementById("pdSku");
    if (skuEl) skuEl.textContent = variant.sku || "—";

    var addBtn = document.getElementById("addBtn");
    var addLabel = document.getElementById("addBtnLabel");
    if (addBtn) {
      addBtn.setAttribute("data-variant-id", variant.id);
      addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? "Add to Cart" : "Sold Out";
    }

    if (variant.featured_image && variant.featured_image.src) {
      var mainImg = document.getElementById("pdMainImg");
      if (mainImg) mainImg.src = variant.featured_image.src.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, "_900x$1$2");
    }

    updateWhatsAppLink(variant);
    window.MARVIQ.cartItemCount = window.MARVIQ.cartItemCount; // no-op, keeps lint quiet
  }

  function updateWhatsAppLink(variant) {
    var waBtn = document.getElementById("waBtn");
    if (!waBtn || !extra.whatsappNumber) return;
    var qty = parseInt((document.getElementById("qtyVal") || {}).textContent || "1", 10);
    var variantDesc = variant.options.filter(function (o) { return o && o !== "Default Title"; }).join(", ");
    var msg = "Hi MARVIQ, I would like to book this product: " + (extra.productTitle || product.title) +
      (variantDesc ? " (" + variantDesc + ", Qty: " + qty + ")" : " (Qty: " + qty + ")") +
      " — " + formatMoney(variant.price);
    waBtn.href = "https://wa.me/" + extra.whatsappNumber + "?text=" + encodeURIComponent(msg);
  }

  /* ---------- Option buttons (size / color / any option) ---------- */
  section.querySelectorAll(".pd-sizes .size-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var group = btn.closest(".pd-sizes");
      var optionIndex = parseInt(group.getAttribute("data-option-index"), 10);
      var value = btn.getAttribute("data-value");

      selectedOptions[optionIndex] = value;
      group.querySelectorAll(".size-btn").forEach(function (b) { b.classList.remove("active"); });
      btn.classList.add("active");

      var variant = findVariant(selectedOptions);
      if (variant) {
        render(variant);
        // Sync the URL so refreshes / shares keep the chosen variant.
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", variant.id);
          window.history.replaceState({}, "", url);
        }
      }
    });
  });

  // Disable buttons for combinations with zero availability across all other option choices.
  section.querySelectorAll(".pd-sizes").forEach(function (group) {
    var optionIndex = parseInt(group.getAttribute("data-option-index"), 10);
    group.querySelectorAll(".size-btn").forEach(function (btn) {
      var value = btn.getAttribute("data-value");
      if (!isCombinationAvailable(optionIndex, value)) btn.setAttribute("disabled", "disabled");
    });
  });

  /* ---------- Gallery thumbnails ---------- */
  section.querySelectorAll(".pd-thumb").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      var mainImg = document.getElementById("pdMainImg");
      if (mainImg) mainImg.src = thumb.getAttribute("data-img");
      section.querySelectorAll(".pd-thumb").forEach(function (t) { t.classList.remove("active"); });
      thumb.classList.add("active");
    });
  });

  /* ---------- Quantity stepper ---------- */
  var qtyVal = document.getElementById("qtyVal");
  var qtyPlus = document.getElementById("qtyPlus");
  var qtyMinus = document.getElementById("qtyMinus");
  function currentQty() { return parseInt((qtyVal && qtyVal.textContent) || "1", 10); }
  if (qtyPlus) qtyPlus.addEventListener("click", function () {
    qtyVal.textContent = currentQty() + 1;
    updateWhatsAppLink(findVariant(selectedOptions) || product.variants[0]);
  });
  if (qtyMinus) qtyMinus.addEventListener("click", function () {
    if (currentQty() > 1) qtyVal.textContent = currentQty() - 1;
    updateWhatsAppLink(findVariant(selectedOptions) || product.variants[0]);
  });

  /* ---------- Wishlist button ---------- */
  var wishBtn = document.getElementById("wishBtn");
  if (wishBtn && window.MarviqWishlist) {
    if (window.MarviqWishlist.has(wishBtn.dataset.wishId)) wishBtn.classList.add("active");
    wishBtn.addEventListener("click", function () {
      window.MarviqWishlist.toggle(wishBtn.dataset.wishId, wishBtn.dataset.wishHandle, product.title, product.featured_image);
      wishBtn.classList.toggle("active");
    });
  }

  /* ---------- Accordion ---------- */
  section.querySelectorAll(".pd-acc-head").forEach(function (head) {
    head.addEventListener("click", function () {
      head.closest(".pd-acc").classList.toggle("open");
    });
  });

  /* ---------- Initial WhatsApp link ---------- */
  updateWhatsAppLink(product.selected_or_first_available_variant || product.variants[0]);

  /* ---------- Related products (native Shopify recommendations) ---------- */
  var relatedGrid = document.getElementById("relatedGrid");
  if (relatedGrid && relatedGrid.dataset.recommendationsUrl && relatedGrid.children.length === 0) {
    fetch(relatedGrid.dataset.recommendationsUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var wrapper = document.createElement("div");
        wrapper.innerHTML = html;
        var freshGrid = wrapper.querySelector("#relatedGrid");
        if (freshGrid && freshGrid.innerHTML.trim() !== "") {
          relatedGrid.innerHTML = freshGrid.innerHTML;
        } else {
          var relatedSection = document.getElementById("relatedSection");
          if (relatedSection) relatedSection.style.display = "none";
        }
      })
      .catch(function () {});
  }
})();
